export default function GS_Functions() {
  return (
    <div className="p-4">
      <h1>GS Functions</h1>
    </div>
  );
}
